import rg4js from 'raygun4js'
import VeeValidate from 'vee-validate'
import vmodal from 'vue-js-modal'
import VueGTM from 'vue-gtm'
import VTooltip from 'v-tooltip'
import ResponseTap from './plugins/ResponseTap'
import DevBox from './plugins/DevBox'

export default function bootstrap (Vue, { router, store }) {
  Vue.config.productionTip = false

  rg4js('apiKey', process.env.VUE_APP_RAYGUN_API_KEY)
  rg4js('enableCrashReporting', true)

  rg4js('onBeforeSend', function (payload) {
    return ['testing', 'staging', 'production'].includes(process.env.NODE_ENV) ? payload : false
  })

  if ((!store.state.Dev || !store.state.Dev.disableResponseTap) && process.env.VUE_APP_RESPONSE_TAP_SELECTOR) {
    Vue.use(ResponseTap, {
      router,
      selector: process.env.VUE_APP_RESPONSE_TAP_SELECTOR,
      setter: value => {
        store.commit('SET_CAMPAIGN', { micPhoneNumber: value })
      }
    })
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`
  })
  const { VUE_APP_GTM_ID } = process.env
  if (VUE_APP_GTM_ID) Vue.use(VueGTM, { id: VUE_APP_GTM_ID, vueRouter: router })

  Vue.prototype.$brandName = process.env.VUE_APP_BRAND || 'bionic'

  Vue.use(DevBox)
  Vue.use(VeeValidate)
  Vue.use(vmodal, { dynamic: true })
  Vue.use(VTooltip)
}
